import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.g2{min-height:100vh;}.ssr-plugin'
import '.eg{background:var(--palette-white);}.ssr-plugin'
import '.ai{max-width:77.5rem;}.ssr-plugin'
import '.g3{align-self:center;}.ssr-plugin'
import '.ac{flex-shrink:0;}.ssr-plugin'
import '.g4{padding-block:1rem;}.ssr-plugin'
import '.fy{gap:0.75rem;}.ssr-plugin'
import '.g5{height:3rem;}.ssr-plugin'
import '.al{justify-content:space-between;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ao{flex-wrap:wrap;}.ssr-plugin'
import '.g6{height:0.25rem;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.g7{border-radius:999px;}.ssr-plugin'
import '.g8{background:var(--gray-200);}.ssr-plugin'
import '.av{height:100%;}.ssr-plugin'
import '.cj{background:var(--brand-primary);}.ssr-plugin'
import '.g9{transition:width 0.3s ease;}.ssr-plugin'
import '.ax{flex:1;}.ssr-plugin'
import '.ct{min-height:0px;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.ga{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
  progress,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
  progress?: { current: number; total: number }
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d e g2 eg"
      >
        <div className="ai g3 ac"
          style={{
            width: isMobile ? '100%' : '85%',
            paddingInline: isMobile ? '5rem' : 0,}}
        >
          <nav className="g4 d e fy"
          >
            <div className="g5 d al t ao"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </div>
            {progress && progress.total > 0 && (
              <div className="g6 l g7 g8"
              >
                <div className="av g7 cj g9"
                  style={{
                    width: `${(progress.current / progress.total) * 100}%`,}}
                />
              </div>
            )}
          </nav>
        </div>
        <div className="ax ct d e r ga ai g3"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%',
            paddingInline: isMobile ? '5rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
